import { createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";
import { notificationObject } from "src/constant";
import { getAxios } from "src/helpers/index";

/** API call to retrieve all client with projects data -----------------------**/
export const getAllClientProject = createAsyncThunk(
  "clientProjects/getAllClientProject", async (model, thunkAPi) => {
    try {
      let res = await getAxios().get("/Client");
      let clientData = _.filter(res?.data || [], (d) => d.isActive);
      let NewData = _.orderBy(clientData, ["createdOn"], ["desc"])
      return thunkAPi.fulfillWithValue(NewData);
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

/** API call to add new client ------------------------------- **/
export const addClient = createAsyncThunk(
  "clientProjects/addClient",
  async (model, thunkAPi) => {
    try {
      let notficationObj = {
        ClientName: model?.name,
        ...notificationObject("Client", "Created")
      }
      let res = await getAxios().post("/Client", model);
      await getAxios().post("/ActivityLog", { activityLogs: [JSON.stringify(notficationObj)] });
      return thunkAPi.fulfillWithValue(res.data);
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

/** API call to retrieve individual client data by id --------------------- **/
export const getByIdClient = createAsyncThunk(
  "clientProjects/getByIdClient",
  async (model, thunkAPi) => {
    try {
      let res = await getAxios().get(`/Client/${model.id}`);
      return thunkAPi.fulfillWithValue(res.data);
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

/** API call to retrieve all project managers data ------------------------ **/
export const getAllProjectManagers = createAsyncThunk(
  "clientProjects/getAllProjectManagers",
  async (model, thunkAPi) => {
    try {
      let res = await getAxios().get("User");
      let filterData = _.filter(res.data, (d) => d.isProjectManager || d?.roles?.includes("ProjectManager"));
      let result = _.orderBy(filterData, ["raisedOn"], ["desc"])
      return thunkAPi.fulfillWithValue(result);
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);


/** API call to retrieve all clients data with projects ---------------------------- **/
export const getAllClientsWithProjects = createAsyncThunk("clientProjects/getAllClientsWithProjects", async (model, thunkAPi) => {
  try {
    let res = await getAxios().get("/client");
    return res.data;
  } catch (error) {
    return thunkAPi.rejectWithValue(error);
  }
});


/** API call to add new project manager ------------------------- **/
export const addProjectManager = createAsyncThunk(
  "clientProjects/addProjectManager",
  async (model, thunkAPi) => {
    try {
      let res = await getAxios().get("api/projectmanager");
      return thunkAPi.fulfillWithValue(res.data);
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

/** API call to add new project -------------------- **/
export const addProject = createAsyncThunk(
  "clientProjects/addProject",
  async (model, thunkAPi) => {
    try {
      let notficationObj = {
        ClientName: model?.clientName,
        ResourceName: model?.name,
        ...notificationObject("Project", "Create")
      }
      let res = await getAxios().post("/Project", model);
      await getAxios().post("/ActivityLog", { activityLogs: [JSON.stringify(notficationObj)] });
      return thunkAPi.fulfillWithValue(res.data);
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

/** API call to edit existing project ----------------- **/
export const editProject = createAsyncThunk(
  "clientProjects/editProject",
  async (model, thunkAPi) => {
    try {
      let notficationObj = {}
      let NotificationArray = []
      if (model?.GrantAppAccessTrue) {
        model?.data?.users?.map((data) => {
          notficationObj = {
            UserDetails: (data?.firstName || "") + " " + (data?.middleName || "") + " " + (data?.middleName || ""),
            ResourceName: model?.data?.name || "",
            ...notificationObject("Project", model?.flag ? "User Allocated" : "User Deallocated")
          }
          NotificationArray.push(JSON.stringify(notficationObj))
        })
      } else {
        notficationObj = {
          ClientName: model?.data?.clientName,
          ResourceName: model?.data?.name,
          ...notificationObject("Project", "Update")
        }
      }
      let activityLogsObj = NotificationArray.length > 0 ? [...NotificationArray] : [JSON.stringify(notficationObj)]

      let res = await getAxios().put(`/Project/${model.id}`, model.data);
      await getAxios().post("/ActivityLog", { activityLogs: activityLogsObj });
      return thunkAPi.fulfillWithValue(res.data);
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

/** API call to unlist project ------------------------- **/
export const unlistProject = createAsyncThunk(
  "clientProjects/unlistProject",
  async (model, thunkAPi) => {
    try {
      let notficationObj = {
        ResourceName: model?.name,
        ...notificationObject("Project", "Delete")
      }
      await getAxios().delete(`/Project/${model?.id}`);
      await getAxios().post("/ActivityLog", { activityLogs: [JSON.stringify(notficationObj)] });
      return true
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);


/** API call to unlist client ---------------------- **/
export const unlistClient = createAsyncThunk(
  "clientProjects/unlistClient",
  async (model, thunkAPi) => {
    try {
      let notficationObj = {
        ResourceName: model?.name,
        ClientName: model?.name,
        ...notificationObject("Client", "Delete")
      }
      let res = await getAxios().delete(`/Client/${model?.id}`);
      await getAxios().post("/ActivityLog", { activityLogs: [JSON.stringify(notficationObj)] });
      return res.data;
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

/** API call to edit client ------------------------------- **/
export const editClient = createAsyncThunk(
  "clientProjects/editClient",
  async (model, thunkAPi) => {
    try {
      let res = await getAxios().put(`/Client/${model?.id}`, model);
      let notficationObj = {
        ClientName: model?.name,
        ...notificationObject("Client", "Update")
      }
      await getAxios().post("/ActivityLog", { activityLogs: [JSON.stringify(notficationObj)] });
      return thunkAPi.fulfillWithValue(res.data);
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);
